import request from '@/utils/request'

export function createTopic(data) {
  return request({ url: '/discussion/topic', method: 'post', data })
}

export function listTopicsByCourse(courseId) {
  return request({ url: `/discussion/topic/byCourse/${courseId}`, method: 'get' })
}

export function deleteTopic(topicId) {
  return request({ url: `/discussion/topic/${topicId}`, method: 'delete' })
}

export function createReply(data) {
  return request({ url: '/discussion/reply', method: 'post', data })
}

export function listRepliesByTopic(topicId) {
  return request({ url: `/discussion/reply/byTopic/${topicId}`, method: 'get' })
}

export function deleteReply(replyId) {
  return request({ url: `/discussion/reply/${replyId}`, method: 'delete' })
}
